import React from 'react';
import styled, {css} from 'styled-components';
import { ReactComponent as Plus } from '../../../../assets/icons/plus.svg';
import { ReactComponent as Minus } from '../../../../assets/icons/minus.svg';
import { ReactComponent as Next } from '../../../../assets/icons/next.svg';
import { ReactComponent as Back } from '../../../../assets/icons/back.svg';
import { ReactComponent as Open } from '../../../../assets/icons/open.svg';
import { ReactComponent as Info } from '../../../../assets/icons/info.svg';
import { ReactComponent as Insert } from '../../../../assets/icons/insert.svg';
import { ReactComponent as Sun } from '../../../../assets/icons/sun.svg';
import { ReactComponent as Moon } from '../../../../assets/icons/moon.svg';
import { ReactComponent as Search } from '../../../../assets/icons/search.svg';
import { ReactComponent as Delete } from '../../../../assets/icons/delete.svg';
import { ReactComponent as Edit } from '../../../../assets/icons/edit.svg';
import { ReactComponent as Close } from '../../../../assets/icons/close.svg';
import { ReactComponent as Settings } from '../../../../assets/icons/settings.svg';
import { ReactComponent as Repeat } from '../../../../assets/icons/repeat.svg';
import { ReactComponent as ArrowDown } from '../../../../assets/icons/arrowDown.svg';
import { ReactComponent as Quality } from '../../../../assets/icons/quality.svg';
import { ReactComponent as Timeload } from '../../../../assets/icons/timeload.svg';
import { ReactComponent as Passed } from '../../../../assets/icons/passed.svg';
import { ReactComponent as Ava } from '../../../../assets/icons/ava.svg';
import { ReactComponent as Menu } from '../../../../assets/icons/menu.svg';
import { ReactComponent as MenuClose } from '../../../../assets/icons/menuClose.svg';
import { ReactComponent as Camera } from '../../../../assets/icons/camera.svg';
import { ReactComponent as Copy } from '../../../../assets/icons/copy.svg';
import { ReactComponent as Img } from '../../../../assets/icons/img.svg';
import { ReactComponent as Pro } from '../../../../assets/icons/pro.svg';
import { ReactComponent as Share } from '../../../../assets/icons/share.svg';
import { ReactComponent as Play } from '../../../../assets/icons/play.svg';
import { ReactComponent as ArrowCheck } from '../../../../assets/icons/arrowCheck.svg';
import { ReactComponent as Check } from '../../../../assets/icons/check.svg';
import { ReactComponent as Like } from '../../../../assets/icons/like.svg';
import { ReactComponent as Star } from '../../../../assets/icons/star.svg';
import { ReactComponent as Heart } from '../../../../assets/icons/heart.svg';
import { ReactComponent as Dislike } from '../../../../assets/icons/dislike.svg';
import { ReactComponent as Report } from '../../../../assets/icons/report.svg';
import { ReactComponent as Ru } from '../../../../assets/icons/lang/ru.svg';
import { ReactComponent as Eng } from '../../../../assets/icons/lang/eng.svg';
import { ReactComponent as Insta } from '../../../../assets/icons/social/insta.svg';
import { ReactComponent as VK } from '../../../../assets/icons/social/vk.svg';
import { ReactComponent as FB } from '../../../../assets/icons/social/fb.svg';
import { ReactComponent as YouTube } from '../../../../assets/icons/social/youtube.svg';
import { ReactComponent as Telegram } from '../../../../assets/icons/social/telegram.svg';
import { ReactComponent as Twitter } from '../../../../assets/icons/social/twitter.svg';
import { ReactComponent as Apple } from '../../../../assets/icons/social/apple.svg';
import { ReactComponent as Google } from '../../../../assets/icons/social/google.svg';
import { ReactComponent as Loader } from '../../../../assets/icons/loader.svg';
import { ReactComponent as AppStore } from '../../../../assets/icons/social/appstore.svg';
import { ReactComponent as GooglePlay } from '../../../../assets/icons/social/googleplay.svg';
import { ReactComponent as WhatsApp } from '../../../../assets/icons/social/whatsapp.svg';
import { ReactComponent as Reddit } from '../../../../assets/icons/social/reddit.svg';
import {basicColor} from '@/styles/template'


export type NameType =
    'Plus' | 'Minus' | 'Next' | 'Back' | 'Open' | 'Info' | 'Insert' | 'Search' |
    'Delete' | 'Edit' | 'Close' | 'Settings' | 'Repeat' | 'ArrowDown' | 'Quality' |
    'Timeload' | 'Passed' | 'Ava' | 'Menu' | 'MenuClose' | 'Camera' | 'Copy' |
    'Pro' | 'Share' | 'Play' | 'ArrowCheck' | 'Check' |
    'Like' | 'Star' | 'Heart' | 'Dislike' | 'Report' |
    'Ru' | 'Eng' |
    'Insta' | 'VK' | 'FB' | 'YouTube' | 'Telegram' | 'Twitter' | 'Apple' | 'Google' |
    'Loader' | 'AppStore' | 'GooglePlay' | 'WhatsApp' | 'Reddit' | 'Sun' | 'Moon' | 'Img'
    ;

export const components: { [key in NameType]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> } = {
    Plus, Minus, Next, Back, Open, Info, Insert, Search,
    Delete, Edit, Close, Settings, Repeat, ArrowDown, Quality,
    Timeload, Passed, Ava, Menu, MenuClose, Camera, Copy,
    Pro, Share, Play, ArrowCheck, Check,
    Like, Star, Heart, Dislike, Report,
    Ru, Eng,
    Insta, VK, FB, YouTube, Telegram, Twitter, Apple, Google, Loader,
    AppStore, GooglePlay, WhatsApp, Reddit, Sun, Moon, Img

};

interface PropsType {
    name: NameType
    small?: boolean
    xSmall?: boolean
    size?: number | undefined
    autoSize?: boolean
}

const Icon:React.FC<PropsType> = (props) => {
    const Svg = components[props.name];
    return <Wrap {...props}><Svg /></Wrap>
}

export default Icon;

// class="midtoneIcon"
// class="lightIcon"
// class="itemBg"
// class="themedIcon"
// class="primary"
// class="accent"
// class="secondary"
// class="red"

const Wrap = styled.div<PropsType>`
    width: 3rem;
    height: 3rem;
    display: inline-flex;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    
    & .primary {
        fill: ${basicColor.primary};
    }

    & .accent {
      fill: ${basicColor.accent};
    }

    & .secondary {
      fill: ${basicColor.secondary};
    }
  
    & .red {
      fill: ${basicColor.red};
    }
    
    & .lightIcon {
      fill: ${props => props.theme.color.LightItem};
    }
    
    & .midtoneIcon {
        fill: ${props => props.theme.color.MidtoneItem};
    }

    & .themedIcon {
      fill: ${props => props.theme.color.MidtoneItem};
    }

    & .primaryStroke {
        stroke: ${basicColor.primary};
    }
    
    & .colorStroke {
        stroke: ${props => props.theme.color.Text};
    }
  
    & .itemBg {
      fill: ${props => props.theme.color.Item};
    }

    ${({ autoSize }) => autoSize && css`
        & {
            height: auto !important;
            width: auto !important;
        }
    `}
    
    ${({ size }) => size && css`
        & {
            height: ${size}rem;
            width: ${size}rem;
        }
    `}
    
    
    ${({ small }) => small && css`
        & svg {
            height: 2rem;
            width: 2rem;
        } 
        
         & .colorStroke {
            stroke-width: 4px;
        } 
    `}
    
     ${({ xSmall }) => xSmall && css`
        & svg {
            height: 1.3rem;
            width: 1.3rem;
        }
        
         & .colorStroke {
            stroke-width: 4px;
        }
    `}
`